
export { EventName } from "./src/interfaces/event"
export { PageName } from "./src/interfaces/event"
export { createFetchWebEventCollector } from "./src/api"